export default {
  install(app, options) {
    app.config.globalProperties.$pageTitle = (title) => {
      document.title = title ? title : "Financial Cents"
    }

    app.config.globalProperties.$resetPageTitle = () => {
      document.title = "Financial Cents"
    }
  },
}
